import module from 'nominas/nomina/module.js'
import template from './template.html'

export default class NominasNominaDocumentosTabuladoGenerarComponent {
  idProyecto = null
  idNomina = null
  data = {}
  onClose
  procesando = false
  error = null
  resultado = null
  version = '2'

  constructor (NominasNominaExportar, NominasNominaDocumentosTabulado, $file) {
    this.NominasNominaExportar = NominasNominaExportar
    this.NominasNominaDocumentosTabulado = NominasNominaDocumentosTabulado
    this.$file = $file
  }

  cancelar () {
    if (this.procesando) return

    this.cerrar()
  }

  cerrar () {
    this.onClose({$event: {detail: this.resultado}})
  }

  descargar () {
    if (!this.resultado) return

    this.version === '1'
      ? this.$file.saveAs(this.resultado, this.resultado.name) : this.resultado.data.save()
  }

  generar () {
    if (this.procesando) return

    this.procesando = true
    this.error = null

    let consulta = this.version === '1'
      ? this.NominasNominaExportar.excel(this.idProyecto, this.idNomina, this.data)
      : this.NominasNominaDocumentosTabulado.get(this.idProyecto, this.idNomina, this.data)

    consulta
      .then((resultado) => (this.resultado = resultado))
      .catch((response) => (this.error = response.data || response))
      .finally(() => (this.procesando = false))
  }
}

module.component('nominasNominaDocumentosTabuladoGenerar', {
  controller: NominasNominaDocumentosTabuladoGenerarComponent,
  template,
  bindings: {
    idProyecto: '<',
    idNomina: '<',
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/documentos/tabulado/generar/component.js